export default "__VITE_ASSET__JA$vv1AF__"